import { Switch } from 'react-router-dom'
import Route from './Route'
import NotFound from 'shared/pages/NotFound'

const Redirect404 = (): JSX.Element => {
  return (
    <Switch>
      <Route path="/404" isPrivate component={NotFound} />
      <Route path="*" isPrivate component={undefined} />
    </Switch>
  )
}

export default Redirect404
